import { render, staticRenderFns } from "./buy_new.vue?vue&type=template&id=5432d6b5&scoped=true&"
import script from "./buy_new.vue?vue&type=script&lang=js&"
export * from "./buy_new.vue?vue&type=script&lang=js&"
import style0 from "./buy_new.vue?vue&type=style&index=0&id=5432d6b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5432d6b5",
  null
  
)

export default component.exports